/**
 * useTaskPhotos — list photos already uploaded against a cleaning task.
 * Used by PhotoUploader to render existing uploads + by the submit guard
 * to know whether all required categories have at least one photo.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useSupabase }                    from './useSupabase'

export interface TaskPhotoRow {
  id:               string
  photo_category:   string
  storage_path:     string
  captured_at:      string | null
}

export function useTaskPhotos(taskId: string | undefined): UseQueryResult<TaskPhotoRow[]> {
  const supabase = useSupabase()

  return useQuery({
    queryKey: ['task-photos', taskId],
    enabled:  !!taskId,
    queryFn: async (): Promise<TaskPhotoRow[]> => {
      if (!taskId) return []
      const { data, error } = await supabase
        .from('room_photos')
        .select('id, photo_category, storage_path, captured_at')
        .eq('cleaning_task_id', taskId)
        .order('captured_at', { ascending: true })
      if (error) throw error
      return (data ?? []) as unknown as TaskPhotoRow[]
    },
  })
}
